// OurTeam.js
// ============================================================================
// ACTION REQUIRED BEFORE LAUNCH - PLACEHOLDER PEOPLE
// The four names, roles and photographs that were here belonged to the source
// site this codebase was cloned from. They are NOT Ivipass staff and have been
// replaced with neutral placeholders so the component still renders.
// A human must either (a) supply real Ivipass people plus their own photographs
// (the images in src/assets/team/ are also inherited and must be replaced), or
// (b) remove <OurTeam /> from src/pages/AboutUs.js entirely.
// Do not ship this section as it stands.
// ============================================================================
import React from 'react';
import { motion } from 'framer-motion';

const OurTeam = () => {
  const teamMembers = [
    {
      name: 'Team member',
      position: 'Role to be confirmed',
      image: 'team-1.jpg'
    },
    {
      name: 'Team member',
      position: 'Role to be confirmed',
      image: 'team-2.jpg'
    },
    {
      name: 'Team member',
      position: 'Role to be confirmed',
      image: 'team-3.jpg'
    },
    {
      name: 'Team member',
      position: 'Role to be confirmed',
      image: 'team-4.jpg'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Our Team
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-3xl mx-auto">
            Details of the people who make up the Ivipass team are being confirmed and will be published here.
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              {/* Team Member Image */}
              <div className="mb-4 overflow-hidden rounded-lg shadow-md">
                <img
                  src={require(`../../assets/team/${member.image}`)}
                  alt={member.name}
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Name */}
              <h3 className="text-lg font-semibold text-primary mb-2">
                {member.name}
              </h3>

              {/* Position */}
              <p className="text-sm text-gray-600 font-light">
                {member.position}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom Text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-gray-700 text-sm font-light leading-relaxed">
            However the team is finally listed, the way it works will not change: clear guidance, replies that arrive when promised, and the same standard of help from start to finish.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default OurTeam;
